/**
 * @ngdoc Controller
 * @name ActivityFeedController
 */

import { handleFileDownload } from "@/utils/download";

(function() {
    "use strict";
    angular
        .module("vrm.core")
        .controller(
            "AdminInstallationsController",
            AdminInstallationsController
        );

    /**
     * @constructor
     * @ngInject
     */
    function AdminInstallationsController(
        $log,
        $rootScope,
        $scope,
        $interval,
        $location,
        $q,
        $timeout,
        AdminTableService,
        GraphService,
        locale,
        ApiService,
        VrmModalService,
        vrmNotificationsService,
        vrmNotificationType,
        vrmUserAccessLevel,
        UserService,
        NgTableParams
    ) {
        $log.info("AdminInstallationsController");
        $scope.table = new AdminTableService("installations");
        $scope.isAdmin = false;
        $scope.vdgData = {};
        $scope.visible = {};
        $scope.activeInstallations = null;
        $scope.installationCountPromise = null;
        $scope.installationStatsLoading = false;
        $scope.activeInstallationsLoading = false;
        $scope.num_records = 0;

        $scope.advancedFilter = {
            open: false,
            query: "",
            lastSuccessfulQuery: "",
            isLoading: true,
            num_records: 0,
            fetchedData: false,
            dataPromise: null,
            params: null,
            extraColumns: [],
            filteringByDataAttribute: false
        }
        $scope.applyAdvancedFilter = function () {
            switchTableMode();
            addFilterToUrlParams();
            $scope.advancedFilter.filteringByDataAttribute = true;
            $scope.advancedFilter.isLoading = true;
            if ($scope.advancedFilter.open && $scope.advancedFilter.fetchedData) {
                $scope.advancedFilter.params = getAdvancedParams();
            }
        };

        $scope.$watch('table.state.isLoading', refreshActiveInstallations);

        $scope.$watch('table.state.total', function() {
            if (!$scope.advancedFilter.open) {
                $scope.num_records = $scope.table.state.total;
            }
        });

        // If both of these are loading, make sure we only show one spinner
        $scope.$watchGroup(['activeInstallationsLoading', 'installationCountPromise'], function() {
            $scope.installationStatsLoading = $scope.activeInstallationsLoading && $scope.installationCountPromise !== null;
        });

        function refreshActiveInstallations(isLoading) {
            if (isLoading) {
                return
            }

            $scope.activeInstallationsLoading = true;

            ApiService.admin('active-installations-count')
                .then(function (response) {
                    $scope.activeInstallations = response.data.count;
                })
                .finally(() => {
                    $scope.activeInstallationsLoading = false;
                })
        }


        GraphService.ready().then(function() {
            $scope.chart = {
                size: {
                    height: 200
                },
                options: {},
                xAxis: {
                    categories: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                    ]
                },
                yAxis: {
                    title: {
                        text: locale.getString(
                            "admin.chart_installations_title"
                        )
                    }
                },
                chart: {
                    zoomType: "x",
                    marginTop: 45
                },
                tooltip: {
                    shared: true,
                    animation: false,
                    headerFormat: ""
                },
                title: {
                    text: ""
                },
                subtitle: {
                    text: ""
                },
                legend: {
                    enabled: true
                },
                credits: {
                    enabled: false
                },
                series: [],
                loading: true
            };
            ApiService.call("/admin/installation-stats/").then(function(
                response
            ) {
                $scope.chart.series = response.data.series;
                $scope.chart.loading = false;
            });
        });

        $scope.queryHelp = function() {
            VrmModalService.openAttributeSearchModal();
        };

        function getAdvancedParamsInstallationCount() {
            $scope.installationCountPromise = ApiService.call2('/admin/installation-data-attributes-count', { query: $scope.advancedFilter.query }, {
                method: "GET",
            });

            // This promise is used to keep track of the latest request
            const canceler = $q.defer();
            $scope.installationCountPromise.canceler = canceler.promise;

            $scope.installationCountPromise.then(response => {
                // Check if the current promise is the same one we are expecting
                if ($scope.installationCountPromise.canceler !== canceler.promise) {
                    return;
                }

                // Set this to null to indicate we are no longer waiting for the count
                $scope.installationCountPromise = null;
                $scope.advancedFilter.num_records = response.data.num_records;

                if ($scope.advancedFilter.open) {
                    $scope.num_records = $scope.advancedFilter.num_records;
                }
            });
        }

        $scope.downloadSearchResults = function() {
            if ($scope.advancedFilter.open) {
                var data = {
                    table: "dataAttribute",
                    query: $scope.advancedFilter.lastSuccessfulQuery
                }
            } else {
                let params = $location.search();
                var data = {
                    table: "normal",
                    filters: {},
                }

                for (let key in params) {
                    if (!params.hasOwnProperty(key)) continue;

                    if (key.startsWith('filter[') && key.endsWith(']')) {
                        let attribute = key.slice(7, -1); // Extract the attribute name from "filter[attribute]"
                        data.filters[attribute] = params[key];
                    } else {
                        //count, page and sorting will go here
                        data[key] = params[key];
                    }

                }
            }

            ApiService.download("/admin/search-download", data, false).then(response => {
                handleFileDownload(response.data, "Installation overview search.xlsx");
            })
        }

        function getAdvancedParams() {
            getAdvancedParamsInstallationCount();

            return new NgTableParams(angular.extend({ count: 100 }), {
                counts: [],
                filterOptions: {
                    filterDelay: 1
                },
                getData: function(params) {
                    $scope.advancedFilter.dataPromise = $q.defer();
                    $timeout.cancel($scope.advancedFilter.filterTimeout);
                    $scope.advancedFilter.isLoading = true;
                    $scope.advancedFilter.filterTimeout = $timeout(function() {
                        ApiService.installationDataAttributes(
                            $scope.advancedFilter.query,
                            params.page()
                        )
                            .then(
                                function(response) {
                                    // Set totals to init pagination
                                    params.total(response.data.num_records);
                                    $scope.advancedFilter.fetchedData = true;
                                    $scope.advancedFilter.lastSuccessfulQuery = $scope.advancedFilter.query;
                                    $scope.advancedFilter.extraColumns = response.data.attributes;
                                    if (
                                        $scope.advancedFilter.isLoading ===
                                        false
                                    ) {
                                        // This is an edge case where request just overlap in a weird way, can be fixed by
                                        // simply refetching once.
                                        $scope.advancedFilter.params = getAdvancedParams();
                                    }
                                    $scope.advancedFilter.dataPromise.resolve(
                                        response.data.records
                                    );
                                },
                                function() {
                                    $scope.advancedFilter.dataPromise.reject();
                                }
                            )
                            .finally(function() {
                                $scope.advancedFilter.isLoading = false;
                            });
                    }, 500);
                    return $scope.advancedFilter.dataPromise.promise;
                }
            });
        }

        function switchTableMode() {
            // If the user switches between tables, make sure the total installations reflect the right table
            $scope.num_records = ($scope.advancedFilter.open) ? $scope.advancedFilter.num_records : $scope.table.state.total;

            if (!$scope.advancedFilter.params) {
                $scope.advancedFilter.params = getAdvancedParams();
            }
        }

        function addFilterToUrlParams() {
            if ($scope.advancedFilter.open) {
                $location.search('query', $scope.advancedFilter.query);
            } else {
                $location.search('query', null);
            }
        }

        $scope.$watch(function() {
            return $location.search().query;
        },
        function() {
            if ($location.search().query) {
                initializeFilterFromUrlParams();
            }
        });

        function initializeFilterFromUrlParams() {
            $scope.advancedFilter.filteringByDataAttribute = true;
            const params = $location.search();
            if (params.query) {
                const decodedQuery = decodeURIComponent(params.query);
                $scope.advancedFilter.query = decodedQuery;
                $scope.advancedFilter.open = true;
            }
            if ($scope.advancedFilter.open && $scope.advancedFilter.fetchedData) {
                $scope.advancedFilter.params = getAdvancedParams();
            }
            switchTableMode();
        }

        $scope.handleOpenFilterByDataAttribute = function() {
            if ($scope.advancedFilter.open && $scope.advancedFilter.filteringByDataAttribute) {
                $scope.advancedFilter.filteringByDataAttribute = !$scope.advancedFilter.filteringByDataAttribute;
            }
            $scope.advancedFilter.open = !$scope.advancedFilter.open;
        }
    }
})();
